'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import EnterpriseSecurityGovernance from '@/components/common/enterprise-security-governance';
import ValuePropositionAiSecurityGovernance from '@/components/common/value-proposition-ai-security-governance';
import WhyAiSecurityGovernance from '@/components/common/why-ai-security-governance';
import OurOfferingAiSecurityGovernance from '@/components/common/our-offering-ai-security-governance';
import TechnicalApproachAiSecurityGovernance from '@/components/common/technical-approach-ai-security-governance';
import IntegrationsTechAiSecurityGovernance from '@/components/common/integrations-tech-ai-security-governance';
import AiSecurityGovernanceFAQ from '@/components/faqs/ai-security-governance-faq';
import AiSecurityGovernanceTechStack from '@/components/home/ai-security-governance-tech-stack';
import ArchitectureDiagramAiSecurityGovernance from '@/components/common/architecture-diagram-ai-security-governance';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroAiSecurityGovernance = dynamic(() => import('@/components/technologies/tech-hero-ai-security-and-governance'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroAiSecurityGovernance />
                <EnterpriseSecurityGovernance />
                <ValuePropositionAiSecurityGovernance />
                <WhyAiSecurityGovernance />
                <OurOfferingAiSecurityGovernance />
                <TechnicalApproachAiSecurityGovernance />
                <ArchitectureDiagramAiSecurityGovernance />
                <IntegrationsTechAiSecurityGovernance />
                <AiSecurityGovernanceTechStack />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <TechnologyFaq title="FAQs for AI Security & Governance" bg="bg-aiml-faq">
                    <AiSecurityGovernanceFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
